import { Injectable } from '@angular/core';
// import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { variablesLibelle } from 'src/app/shared/questionnaire.metadata';

/**
 * Modèle d’un objet libell«
 */
export class Libelle {
    public label: string;
    public libelle: string;
}

/**
Service permettant de charger les libellés des différentes variables de
l'application, et d'y accéder par la suite dans les composants qui en
ont besoin.
 */
@Injectable()
export class LibellesService {
    private chargement = '[Chargement en cours …]';
    private url: string;
    private libelles$: Map<string, BehaviorSubject<string>> = new Map();
    private chargementOk: boolean = false;
    // Map contenant les libellés de variable
    public variablesLibelle: Map<string, string>;

    constructor(
        // Avec API : ancienne façon
        // private http: HttpClient,
        // @Inject('API_URL') private apiUrl: string
    ) {}

    /**
    * fonction d’initialisation des données métiers du service
    */
    /*
        // Avec API : ancienne façon
        public init(): void {
            this.url = this.apiUrl + '/libelles';
            this.http.get(this.url).subscribe(libelles => {
            Object.keys(libelles).forEach(element => {
                this.getLibelle$(element).next(libelles[element]);
            });
            this.chargementOk = true;
            });
    }*/

    // Chargement à partir de questionnaireMetadata
    public init(): void {
        this.initVariablesLibelle();

        this.variablesLibelle.forEach((libelles, nomVariable) => {
            this.getLibelle$(nomVariable).next(libelles);
        });
        this.chargementOk = true;
    }

    private initVariablesLibelle(): void {
        this.variablesLibelle = variablesLibelle;
    }

    /**
     * Fonction pour obtenir un libellé à partir d’un nom de variable
     */
    public getLibelle$(nomVariable: string): BehaviorSubject<string> {
        /* Si aucun nom de variable fourni, on retourne null … */
        if (!nomVariable) {
            return null;
        }

        if (!this.libelles$.get(nomVariable)) {
            /* Le libellé dans ce cas n’existe pas encore, il faut donc la créer */
            this.libelles$.set(nomVariable, new BehaviorSubject<string>(this.chargement));
        }
        return this.libelles$.get(nomVariable);
    }
    /**
     * Retourne si le chargement des libellés s’est bien passé
     */
    public libellesCharges(): boolean {
        return this.chargementOk;
    }

}
